import { OrganizationControllerApiFactory } from '@api-client/api'
import { QueryKey } from '@helpers/enums'
import { useQuery } from '@tanstack/react-query'

import { useAsyncApi } from './useAsyncApi'

const useOwnOrganisation = () => {
	const organisationControllerApi = useAsyncApi(
		OrganizationControllerApiFactory
	)
	return useQuery({
		queryKey: [QueryKey.GetOwnOrganisation],
		queryFn: () => organisationControllerApi(api => api.getOwnOrganisation()),
	})
}

export { useOwnOrganisation }
